export default "__VITE_ASSET__i_iZRy37__"